<template lang="pug">
  .app-group-item(:class="classes")
    slot
</template>

<script>
export default {
  name: 'app-group-item',
  props: {
    cols: {
      type: [Number, String],
      default: 0
    }
  },
  computed: {
    classes () {
      return this.cols > 0 ? `flex xs${this.cols}` : ''
    }
  }
}
</script>

<style>
.app-group-item {
  padding-left: 16px;
  padding-right: 16px;
  transition: all 0.5s;
}
</style>